// extracted by mini-css-extract-plugin
export default {"wrapper":"BURHABQ","thin-container":"bfmWiEL","thinContainer":"bfmWiEL","title":"_9uJ2coa","subtitle":"_5Cl7Ta-","container":"QBpi3Pv"};